<template>
      <div class="conf-con">
                            <div class="intro-pic">
                              <img src="../../../assets/images/04.jpg" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第四次全国代表大会简介</p>
                            <p class="margin1">国民党一大的召开，标志着第一次国共合作的正式形成。此后，工人运动逐渐恢复，农民运动日益兴起，全国革命形势迅速高涨，形成了以广州为中心的反对帝国主义和封建军阀的革命新局面。</p>
                            <p class="margin1">但是，国共合作并非一帆风顺，在波澜壮阔的大革命洪流中也潜伏着令人不安的暗流。1924年6月，国民党内的右派分子邓泽如、张继、谢持向国民党中央执行委员会提出《弹劾共产党案》，声称共产党员加入国民党“于本党之生存发展，有重大妨害”，“绝对不宜党中有党”。8月，张继等又抛出所谓《护党宣言》，诬蔑共产党员加入国民党的目的是消灭国民党。</p>
                            <p class="margin1">面对国民党右派的进攻，中共中央于7月1日发出党内通告，要求各级党组织坚决揭露国民党右派的反动活动。陈独秀、恽代英、瞿秋白、蔡和森等连续发表文章，痛斥国民党右派违背国民党一大政纲、破坏革命队伍内部团结的反动言行。此刻，摆在共产党人面前的重要问题是：在这场日益高涨的大革命浪潮中，共产党人是应当在国民党的旗帜下为了国民革命运动去组织中国工人、农民以及青年，还是应当由共产党直接去组织群众？</p>
                            <p class="margin1">为了总结国共合作一年来的经验，加强对革命运动的领导，回答党所面临的许多新问题，1925年1月11日至22日，中国共产党第四次全国代表大会在上海召开。出席大会的有陈独秀、蔡和森、瞿秋白、谭平山、周恩来、彭述之、张太雷、陈潭秋、李维汉、李立三、王荷波、项英、向警予等20人，代表着全国994名党员。共产国际代表维经斯基参加了大会。陈独秀代表第三届中央执行委员会作了工作报告。</p>
                            <p class="margin1">大会围绕当前的中心工作，通过了《对于民族革命运动之议决案》等11个议决案，并选出了新的中央执行委员会。新当选的中央执行委员共9人：陈独秀、李大钊、蔡和森、张国焘、项英、瞿秋白、彭述之、谭平山、李维汉；候补执行委员5人：邓培、王荷波、罗章龙、张太雷、朱锦堂。在随后举行的中央执行委员会第一次会议上，陈独秀当选为中央总书记兼中央组织部主任，彭述之任中央宣传部主任，张国焘任中央工农部主任，蔡和森、瞿秋白任中央宣传部委员，以上5人组成中央局。</p>
                            <p class="margin1">党的四大最重要的贡献是第一次明确提出了无产阶级在民主革命中的领导权和工农联盟问题。《对于民族革命运动之议决案》明确指出：“无产阶级的政党应该知道无产阶级参加民族运动，不是附属资产阶级而参加，乃以自己阶级独立的地位与目的参加”。“无产阶级是最有革命性的阶级”。所以，民主革命“必须最革命的无产阶级有力的参加，并且取得领导的地位，才能够得到胜利”。关于工农联盟，《对于农民运动的议决案》阐明了农民是无产阶级同盟军的原理，强调了农民在中国民族革命中的重要地位，指出：如果不发动农民起来斗争，无产阶级的领导地位和中国革命的成功是不可能取得的。此外，大会对中国民主革命的内容作了较完整的规定，指出在“反对国际帝国主义”的同时，既要“反对封建的军阀政治”，又要“反对封建的经济关系”，这表明，此时党已把新民主主义革命基本思想的要点提出来了。</p>
                            <p class="margin1">党的四大作出的各项正确决策，为大革命高潮的到来作了政治上、思想上和组织上的准备。此后，全国的革命形势迅速发展，工人运动风起云涌，农民运动轰轰烈烈，大革命的高潮来临了。 </p>
                        </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>